// FORMA COMUM DOS RETORNOS A CONSIGNATARIA (#189). Os dois layouts de
// `finalidade: "retorno_consignataria"` (o de sete colunas e o da ASSALCE, de
// quatro) escrevem dinheiro, CPF e texto do mesmo jeito; so' as colunas mudam.
/** Centavos inteiros para `1234567,89`: aritmetica inteira, nunca `toFixed`. */
export function reais(centavos) {
    const c = Math.round(Math.abs(centavos));
    return `${Math.trunc(c / 100)},${String(c % 100).padStart(2, "0")}`;
}
/**
 * CPF com 11 digitos. A folha traz o CPF do cadastro; se vier curto e so' de
 * digitos, completa com zeros a esquerda e ACUSA — a consignataria casa por
 * CPF, e um CPF errado e' pior que um arquivo recusado. Nunca lanca: o resto
 * do arquivo continua valendo.
 */
export function cpf11(cpf) {
    const digitos = cpf.replace(/\D/g, "");
    if (digitos.length === 11)
        return { valor: digitos, completado: false };
    if (digitos.length > 0 && digitos.length < 11)
        return { valor: digitos.padStart(11, "0"), completado: true };
    return { valor: digitos, completado: true };
}
/**
 * Texto livre numa coluna: sem acento, sem o separador e sem quebra de linha.
 * O arquivo e' ASCII e posicional por `;` — um `;` no MOTIVO criaria uma
 * coluna a mais, e um acento sairia como lixo no sistema da consignataria.
 */
export function textoLivre(bruto) {
    return bruto
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^\x20-\x7e]|;/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}
/** O arquivo de saida: CRLF, linha final terminada, zero byte quando vazio. */
export function juntarLinhas(linhas) {
    return linhas.length ? `${linhas.join("\r\n")}\r\n` : "";
}
/** O nome que a ASSALCE deu ao arquivo dela (`assalce-retorno`). */
export function nomeRetass(competencia) {
    return `RETASS${competencia}.txt`;
}
/** Palavras que nao entram no nome do arquivo: o "BANCO" e os conectivos. */
const FORA_DO_NOME = new Set(["BANCO", "DO", "DA", "DE", "DOS", "DAS"]);
/**
 * O nome do credor como vai no nome do arquivo (01/10/2026): maiusculas, sem
 * acento, sem `BANCO`, sem os conectivos DO/DA/DE e sem a sigla societaria
 * S.A., com o que sobra JUNTO, sem espacos. `BANCO DO BRASIL S.A.` vira
 * `BRASIL`; `SICREDI COOPERATIVA DE CREDITO` vira `SICREDICOOPERATIVACREDITO`.
 * `null` quando nao sobra nada (um credor chamado so' "Banco").
 */
export function nomeDoCredorNoArquivo(nome) {
    const limpo = nome
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toUpperCase()
        // S.A., S/A, S. A., SA — antes de quebrar em palavras, para nao perder um
        // "A" que seja palavra de verdade.
        .replace(/\bS\s*[./]?\s*A\b\.?/g, " ");
    const palavras = limpo.split(/[^A-Z0-9]+/).filter((p) => p && !FORA_DO_NOME.has(p));
    return palavras.length ? palavras.join("") : null;
}
//# sourceMappingURL=forma-retorno.js.map